import * as ko from "knockout";
import { ResponseContainer } from "../Models/responsecontainer";
import { KnockoutExtensions, NumericValidationOptions } from "../KnockoutExtensions/knockoutextensions";
import { ViewModelBase } from "../ViewModels/viewmodelbase";
import { Event } from "../Models/event";

/**
 * Session manager ViewModel.
 */
export class SessionManagerViewModel extends ViewModelBase {

    constructor() {
        super();

        // Add base timer for 1 miniute
        var self = this;
        var timer = setInterval(function () {
            if (self.readSetting("isLoggedIn") !== null && self.readSetting("isLoggedIn") == "1") {
                var lastAccessed = new Date(localStorage.getItem("lastAccessed"));
                var nowDate = new Date();
                var diffMins = new Date(nowDate.getTime() - lastAccessed.getTime()).getUTCMinutes();
                var diffHours = new Date(nowDate.getTime() - lastAccessed.getTime()).getUTCHours();
                if (diffMins >= 55 || diffHours > 0) {
                    self.sessionExpired();
                    // If session expired ensure session is deactivated
                    self.writeSetting("isLoggedIn", "0");
                }
                if (diffMins >= 1 || diffHours > 0) {
                    self.checkSession(self);
                }
            }
        }, 30000);
    }

    public checkSession(self: SessionManagerViewModel) {
        if (self.readSetting("isLoggedIn") !== null && self.readSetting("isLoggedIn") == "1" &&
            self.readSetting("nutricalc-login") !== null && self.readSetting("nutricalc-login") !== "") {
            self.postJsonData("/api/account/heartbeat", null, function () {
                // Success so continue 
            },
                function (err, status, xhr) {
                    if (err.status == 401) {
                        // Error so check if 401
                        event.stopPropagation();
                        self.writeSetting("isLoggedIn", "0");
                        self.signOut(self);
                    }
                });
        }
    }

    public signOut(self: SessionManagerViewModel) {
        self.postJsonData("/api/account/logout", null, function () {
            // Success so continue 
            self.writeSetting("isLoggedIn", "0");
            self.navigateHome();
        }, function () {
            // Error so assume authentication issue and request signin 
            self.writeSetting("isLoggedIn", "0");
            self.navigateHome();
        });
    }

    /**
     * Navigate to the site home page.
     */
    public navigateHome(): void {
        location.href = "/";
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/sessionmanagerviewmodel.ts